import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoadingService } from '../../common/loading.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit {
  isLoading = false;
  autoLoginInProgress = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private spinner: LoadingService,   
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const token = params['healthtrioToken'];
      if (token) {
        this.autoLoginInProgress = true;
        this.mockLogin('HealthTrio', token);
      }
    });
  }

  //loginWithHealthTrio(): void {
  //  this.isLoading = true;
  //  this.spinner.show();
  //  setTimeout(() => { this.mockLogin('HealthTrio'); }, 1000);
  //}

  loginWithHealthTrio() {
    window.location.href = `${environment.healthTrioAuthUrl}`; // 'https://beta.healthtrioconnect.com/app/index.page?';
  }

  loginWithCareOregon(): void {
    const azureAdLoginUrl = `${environment.sideDoorAPIUri}/Auth/azuread/login`;
    //const azureAdLoginUrl = `/Auth/azuread/login`;
    window.location.href = azureAdLoginUrl;
  }

  private mockLogin(authProvider: string, token?: string): void {
    console.log(`Logging in with ${ authProvider }`, token ? `Token : ${ token }` : '');
    localStorage.setItem('user', JSON.stringify({
      provider: authProvider,
      token: token || 'mock-token'
    }));
    this.spinner.hide();
    this.router.navigate(['']); 
  }
}
